export default __webpack_public_path__ + "static/media/opologic_logo_icon_white.a1a9923b.svg";